import { addToast, Button, Icon, Modal } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import useActions from '../../hooks/useActions';

interface OtherStudiesDeleteModalProps {
  toggleDeleteModal: boolean;
  setToggleDeleteModal: (toggleDeleteModal: boolean) => void;
  refresh: () => Promise<void>;
  idToDelete: number | undefined;
}

export const OtherStudiesDeleteModal = ({
  toggleDeleteModal,
  setToggleDeleteModal,
  refresh,
  idToDelete,
}: OtherStudiesDeleteModalProps) => {
  const { t } = useTranslation();

  const texts = useMemo(() => {
    const prefix = 'studentManagement.educationalInformation';
    return {
      deleteSuccess: t(`${prefix}.form.deleteSuccess`),
      deleteError: t(`${prefix}.form.deleteError`),
      title: t(`${prefix}.deleteModal.title`),
      description: t(`${prefix}.deleteModal.description`),
      cancel: t(`${prefix}.deleteModal.cancel`),
      delete: t(`${prefix}.deleteModal.delete`),
    };
  }, [t]);

  const actions = useActions({
    onSuccess: (type: string) => {
      if (type === 'delete') {
        addToast({
          icon: 'success',
          color: 'success',
          text: texts.deleteSuccess,
        });
        refresh();
      }
    },
    onError: () => {
      addToast({
        icon: 'error',
        color: 'danger',
        text: texts.deleteError,
      });
    },
  });

  if (!idToDelete) return null;

  return (
    <Modal
      isOpen={toggleDeleteModal}
      toggle={() => setToggleDeleteModal(false)}
    >
      <div className="d-flex flex-column align-items-center text-center">
        <Icon name="warning" size={45} />
        <h1 className="text-dark fs-20 mt-3 mb-4">{texts.title}</h1>
        <p className="fs-16 mb-5">{texts.description}</p>
        <Row className="w-100 d-flex justify-content-between">
          <Col xs={12} sm={6} className="pb-2">
            <Button
              text={texts.cancel}
              outlined
              onClick={() => setToggleDeleteModal(false)}
              fullwidth
              loading={actions.loading}
            />
          </Col>
          <Col xs={12} sm={6} className="pb-2">
            <Button
              text={texts.delete}
              onClick={() => actions.deleteOtherStudy(idToDelete)}
              fullwidth
              loading={actions.loading}
            />
          </Col>
        </Row>
      </div>
    </Modal>
  );
};
